import style from "../../../assets/scss/sub/purchase/orderAndPayment.module.scss"
import {getPriceText} from "../../../util/commonFunctions";
import {CartedProduct} from "../../../types/cart";
import {useTranslation} from "react-i18next";

interface Props {
  cartedProducts: CartedProduct[]
}

export default function CartProductItems({cartedProducts}: Props) {
  const { t } = useTranslation("order");

  return <>
    <table className={`${style.items} ${style.desktop}`} cellSpacing="0" cellPadding="0">
      <thead className={style.tableHeader}>
      <tr className={style.headerRow}>
        <th className={style.headerCell} colSpan={2}>{t("cart.productInfo")}</th>
        <th className={style.headerCell}>{t("cart.quantity")}</th>
        <th className={style.headerCell}>{t("cart.regularPrice")}</th>
        <th className={style.headerCell}>{t("cart.discountAmount")}</th>
        <th className={style.headerCell}>{t("cart.productPrice")}</th>
      </tr>
      </thead>
      <tbody className={style.tableBody}>
      {
        cartedProducts?.map((prd, idx) => {
          const product = prd.product;

          return <tr className={style.bodyRow} key={`product-info-${idx}`}>
            <td className={`${style.bodyCell} ${style.detailCell}`} colSpan={2}>
              <div className={style.detailArea}>
                <div className={style.thumbnail}>
                  <img src={product.thumbnail.uri} alt={"상품 이미지"}/>
                </div>
                <span className={style.text}>
                        {product.name}
                      </span>
              </div>
            </td>
            <td className={style.bodyCell}>{prd.quantity}{t("cart.quantityUnit")}</td>
            <td className={style.bodyCell}>
              {getPriceText(prd.totalRegularPrice ?? 0)}{t("cart.priceUnit")}
            </td>
            <td className={`${style.bodyCell} ${style.priceAccent}`}>
              -{getPriceText(prd.totalDiscountAmount ?? 0)}{t("cart.priceUnit")}
            </td>
            <td className={style.bodyCell}>{getPriceText(prd.totalActualAmount ?? 0)}{t("cart.priceUnit")}</td>
          </tr>
        })
      }
      </tbody>
    </table>


    <ul className={`${style.items} ${style.mobile}`}>
      {
        cartedProducts?.map((prd, idx) => {
          const product = prd.product;

          return <li key={idx} className={style.item}>
            <div className={style.thumbnail}>
              <img src={product.thumbnail.uri} alt={"상품 이미지"}/>
            </div>

            <div className={style.productInfo}>
              <span className={style.productName}>{product.name}</span>
              <span className={style.quantity}>{prd.quantity}{t("cart.quantityUnit")}</span>
              <span className={style.priceWrap}>
                <span className={style.sellingPrice}>{getPriceText(product.sellingPrice)}{t("cart.priceUnit")}</span>
                <span className={style.regularPrice}>{getPriceText(product.regularPrice)}{t("cart.priceUnit")}</span>
              </span>
            </div>
          </li>
        })
      }
    </ul>
  </>
}